import { centroid, normalizePolygon, pointInPolygon, polygonArea, polygonBounds } from "./zoneGeometry";

const containsAllVertices = (childPoints, parentPoints) => {
  if (!Array.isArray(childPoints) || !Array.isArray(parentPoints) || parentPoints.length < 3) {
    return false;
  }
  return childPoints.every((pt) => pointInPolygon(pt, parentPoints));
};

export const buildZoneHierarchy = (zones = []) => {
  const meta = zones.map((zone) => {
    const points = normalizePolygon(zone);
    const area = polygonArea(points);
    return {
      ...zone,
      _points: points,
      area,
      bounds: polygonBounds(points),
      parentId: null,
      childrenIds: [],
      depth: 0,
    };
  });

  // Find parent by containment (smallest containing polygon).
  meta.forEach((zoneMeta) => {
    if (!zoneMeta._points.length) return;
    const candidates = meta
      .filter((other) => other.id !== zoneMeta.id && other._points.length >= 3 && other.area >= zoneMeta.area)
      .filter((other) => containsAllVertices(zoneMeta._points, other._points));
    if (!candidates.length) return;
    const parent = candidates.sort((a, b) => a.area - b.area)[0];
    zoneMeta.parentId = parent.id;
  });

  // Build children lists.
  const byId = new Map(meta.map((z) => [`${z.id}`, z]));
  meta.forEach((z) => {
    if (z.parentId != null) {
      const parent = byId.get(`${z.parentId}`);
      if (parent) parent.childrenIds.push(z.id);
    }
  });

  // Compute depth.
  const computeDepth = (z) => {
    if (!z.parentId) return 0;
    const parent = byId.get(`${z.parentId}`);
    if (!parent) return 0;
    return 1 + computeDepth(parent);
  };
  meta.forEach((z) => {
    z.depth = computeDepth(z);
  });

  return meta;
};
